import React, { useState } from 'react';
import Sresult from './Searchresult';

const Search = () => {
  const [img , setImg] = useState('');

  const inputEvent = (event) =>{
    const data = event.target.value;
    console.log(data);
    setImg(data);
  }
  return (
  <>
  <div>
    <div className='row justify-content-center'>
      <div className='col-md-5 text-center'>
        <h1>Search page</h1>
        <input type="text" placeholder='Search Anything' className=' form-control mb-3' value={img} onChange={inputEvent} />
      
        {img === "" ? null : <Sresult name={img}/>}
      </div>
           
    </div>
  </div>
  </>
  );
};

export default Search;
